const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'ship3',
  tiles: {
    blocker_down: 0,
    blocker_up: 1,
    capsule: 2,
    ceiling1: 3,
    ceiling2: 4,
    ceiling3: 5,
    door: 6,
    door3: 7,
    filler: 8,
    floor1: 9,
    floor2: 10,
    floor3: 11,
    pipe_horiz: 12,
    pipe_vert: 13,
    secret: 14,
    solid1: 15,
    solid2: 16,
    solid3: 17,
    solid4: 18,
    solid5: 19,
    stairs_down: 20,
    stairs_up: 21,
    window: 22
  },
  uidata: {
    rects: [
      vec4(8/1024,8/128,40/1024,40/128),
      vec4(56/1024,8/128,88/1024,40/128),
      vec4(104/1024,8/128,136/1024,47/128),
      vec4(152/1024,8/128,184/1024,40/128),
      vec4(200/1024,8/128,232/1024,40/128),
      vec4(248/1024,8/128,280/1024,40/128),
      vec4(296/1024,8/128,328/1024,40/128),
      vec4(344/1024,8/128,376/1024,40/128),
      vec4(392/1024,8/128,424/1024,40/128),
      vec4(440/1024,8/128,472/1024,40/128),
      vec4(488/1024,8/128,520/1024,40/128),
      vec4(536/1024,8/128,568/1024,40/128),
      vec4(584/1024,8/128,616/1024,40/128),
      vec4(632/1024,8/128,664/1024,40/128),
      vec4(680/1024,8/128,712/1024,40/128),
      vec4(728/1024,8/128,760/1024,40/128),
      vec4(776/1024,8/128,808/1024,40/128),
      vec4(824/1024,8/128,856/1024,40/128),
      vec4(872/1024,8/128,904/1024,40/128),
      vec4(920/1024,8/128,952/1024,40/128),
      vec4(968/1024,8/128,1000/1024,40/128),
      vec4(8/1024,63/128,40/1024,95/128),
      vec4(56/1024,63/128,88/1024,95/128)
    ],
    aspect: [
      1,
      1,
      0.8205128205128205,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1,
      1
    ]
  },
  FRAME_BLOCKER_DOWN: 0,
  FRAME_BLOCKER_UP: 1,
  FRAME_CAPSULE: 2,
  FRAME_CEILING1: 3,
  FRAME_CEILING2: 4,
  FRAME_CEILING3: 5,
  FRAME_DOOR: 6,
  FRAME_DOOR3: 7,
  FRAME_FILLER: 8,
  FRAME_FLOOR1: 9,
  FRAME_FLOOR2: 10,
  FRAME_FLOOR3: 11,
  FRAME_PIPE_HORIZ: 12,
  FRAME_PIPE_VERT: 13,
  FRAME_SECRET: 14,
  FRAME_SOLID1: 15,
  FRAME_SOLID2: 16,
  FRAME_SOLID3: 17,
  FRAME_SOLID4: 18,
  FRAME_SOLID5: 19,
  FRAME_STAIRS_DOWN: 20,
  FRAME_STAIRS_UP: 21,
  FRAME_WINDOW: 22
};
spritesheetRegister(module.exports);
